export default function AppEntry() {
  return (
    <section id="app" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="relative bg-background-950 rounded-3xl overflow-hidden">
          <div className="absolute inset-0 opacity-20">
            <img
              src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20abstract%20texture%20with%20soft%20golden%20light%20streaks%20and%20film%20grain%2C%20luxurious%20dark%20velvet%20background%20with%20warm%20amber%20glow%2C%20elegant%20movie%20theater%20atmosphere%2C%20subtle%20bokeh%20effect%2C%20rich%20contrast%2C%20atmospheric%20depth&width=1600&height=600&seq=app-entry-66&orientation=landscape"
              alt=""
              className="w-full h-full object-cover"
              onError={(e) => {
                (e.currentTarget as HTMLElement).style.display = 'none';
              }}
            />
          </div>

          <div className="relative z-10 flex flex-col lg:flex-row items-center gap-8 lg:gap-14 p-8 md:p-14">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="font-heading text-2xl md:text-3xl text-background-50 mb-4">
                随时随地，畅享电影
              </h2>
              <p className="text-sm md:text-base text-background-50/70 leading-relaxed max-w-[480px] mx-auto lg:mx-0 mb-6">
                六六影院已全面适配手机和平板设备。无论是在通勤路上、午休间隙还是睡前时光，打开浏览器即可无缝观影。收藏与观看记录多端同步，不错过任何精彩瞬间。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <div className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-background-50/20 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer hover:border-background-50/40 transition-colors">
                  <i className="ri-apple-line text-lg"></i>
                  iOS 端观看
                </div>
                <div className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-background-50/20 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer hover:border-background-50/40 transition-colors">
                  <i className="ri-android-line text-lg"></i>
                  Android 端观看
                </div>
                <div className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-background-50/20 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer hover:border-background-50/40 transition-colors">
                  <i className="ri-computer-line text-lg"></i>
                  电脑端观看
                </div>
              </div>
            </div>

            <div className="flex-shrink-0">
              <div className="relative w-48 h-80 md:w-56 md:h-[420px] rounded-2xl overflow-hidden border-2 border-background-50/20">
                <img
                  src="https://readdy.ai/api/search-image?query=Mobile%20phone%20screen%20mockup%20showing%20movie%20streaming%20interface%20with%20film%20posters%20grid%2C%20dark%20background%20with%20warm%20golden%20accents%2C%20clean%20minimal%20UI%20design%2C%20cinematic%20app%20interface%2C%20movie%20thumbnails%20in%20grid%20layout%2C%20elegant%20streaming%20platform%20design&width=600&height=1200&seq=app-mockup-66&orientation=portrait"
                  alt="六六影院手机端观影界面"
                  className="w-full h-full object-cover"
                  onError={(e) => {
                    (e.currentTarget as HTMLElement).style.display = 'none';
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}